/* SKARVO "scarf burst" – when a visitor taps Add to cart, small knitted scarves burst out of the button
   and the cart icon gives a little bounce. Does not block or change the add-to-cart itself. */
(() => {
  if (window.__skvBurst) return; window.__skvBurst = true;
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const COLORS = [['#9e1b23', '#efe9df'], ['#141414', '#efe9df'], ['#efe9df', '#9e1b23'], ['#141414', '#9e1b23']];
  const isAddBtn = (el) => {
    const b = el.closest('button, [type="submit"]');
    if (!b) return null;
    if (b.matches('[name="add"], .add-to-cart-button, [data-add-to-cart], add-to-cart-component button')) return b;
    const f = b.closest('form');
    if (f && /\/cart\/add/.test(f.getAttribute('action') || '') && b.type === 'submit') return b;
    return null;
  };
  const scarf = (c1, c2) => {
    const s = document.createElement('i');
    s.className = 'skv-burst';
    s.style.background =
      `repeating-linear-gradient(90deg, ${c1} 0 6px, ${c2} 6px 8px), ${c1}`;
    s.style.setProperty('--fr', c2);
    return s;
  };
  const bounceCart = () => {
    const cart = document.querySelector('[href$="/cart"], .header-actions__cart-icon, cart-icon, .cart-bubble');
    if (cart && cart.animate) cart.animate(
      [{ transform: 'scale(1)' }, { transform: 'scale(1.35) rotate(-8deg)' }, { transform: 'scale(.92)' }, { transform: 'scale(1)' }],
      { duration: 650, delay: 350, easing: 'cubic-bezier(.3,1.6,.5,1)' });
  };
  const burst = (btn) => {
    const r = btn.getBoundingClientRect();
    const x = r.left + r.width / 2, y = r.top + 4;
    const n = reduce ? 0 : (innerWidth < 750 ? 14 : 20);
    for (let i = 0; i < n; i++) {
      const [c1, c2] = COLORS[i % COLORS.length];
      const s = scarf(c1, c2);
      document.body.appendChild(s);
      const ang = (-90 + (Math.random() * 150 - 75)) * Math.PI / 180;   // mostly upwards
      const dist = 90 + Math.random() * 160;
      const dx = Math.cos(ang) * dist, dy = Math.sin(ang) * dist;
      const rot = (Math.random() * 720 - 360) | 0;
      const scale = .7 + Math.random() * .6;
      const dur = 1100 + Math.random() * 500;
      s.style.left = x + 'px'; s.style.top = y + 'px';
      const a = s.animate([
        { transform: `translate(-50%,-50%) scale(.2) rotate(0deg)`, opacity: 1, easing: 'cubic-bezier(.12,.8,.3,1)' },
        { transform: `translate(calc(-50% + ${dx}px), calc(-50% + ${dy}px)) scale(${scale}) rotate(${rot / 2}deg)`, opacity: 1, offset: .5, easing: 'ease-in' },
        { transform: `translate(calc(-50% + ${dx * 1.2}px), calc(-50% + ${dy + 120}px)) scale(${scale * .9}) rotate(${rot}deg)`, opacity: 1, offset: .85 },
        { transform: `translate(calc(-50% + ${dx * 1.25}px), calc(-50% + ${dy + 160}px)) scale(${scale * .85}) rotate(${rot * 1.1}deg)`, opacity: 0 }
      ], { duration: dur, easing: 'linear', fill: 'forwards' });
      a.onfinish = () => s.remove();
    }
    if (btn.animate) btn.animate([{ transform: 'scale(1)' }, { transform: 'scale(.94)' }, { transform: 'scale(1.03)' }, { transform: 'scale(1)' }], { duration: 380, easing: 'ease-out' });
    bounceCart();
  };
  document.addEventListener('click', (e) => {
    const btn = isAddBtn(e.target);
    if (btn && !btn.disabled && btn.getAttribute('aria-disabled') !== 'true') burst(btn);
  }, true);
  window.skvBurstTest = () => { const b = document.querySelector('[name="add"], .add-to-cart-button, form[action*="/cart/add"] [type="submit"]'); if (b) burst(b); };
})();
